import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transformedTreeData: [],
  selectedTreeIds: [],
  finalTreeData: [],
  autocomplete: [],
  bottlerData: [],
  allBottlerList:[],
  allCustomerList:[],
  filterApplied: false,
  manageForecastTreeData: [],
  manageForecastBottlerData: [],
  manageForecastFinalTreeData: [],
  shortTermPeriodList: [],
  longTermPeriodList: []
};

const entitySlice = createSlice({
  name: "entity",
  initialState,
  reducers: {
    setTransformedTreeData: (state, action) => {
      state.transformedTreeData = action.payload;
    },
    setSelectedTreeIds: (state, action) => {
      state.selectedTreeIds = action.payload;
    },
    setFinalTreeData: (state, action) => {
      state.finalTreeData = action.payload;
    },
    setAutocomplete: (state, action) => { // Add this reducer
      state.autocomplete = action.payload;
    },
    setBottlerData: (state, action) => { // Add this reducer
      state.bottlerData = action.payload;
    },
    setAllBottlerList: (state, action) => {
      state.allBottlerList = action.payload;
    },
    setAllCustomerList: (state, action) => {
      state.allCustomerList = action.payload;
    },
    setFilterApplied: (state, action) => {
      state.filterApplied = action.payload;
    },
    setManageForecastTreeData: (state, action) => {
      state.manageForecastTreeData = action.payload;
    },
    setManageForecastBottlerData: (state, action) => {
      state.manageForecastBottlerData = action.payload;
    },
    setManageForecastFinalTreeData: (state, action) => {
      state.manageForecastFinalTreeData = action.payload;
    },
    setStPeriodList: (state, action) => {
      state.shortTermPeriodList = action.payload;
    },
    setLtPeriodList: (state, action) => {
      state.longTermPeriodList = action.payload;
    }

  },
});

export const { setTransformedTreeData, setSelectedTreeIds, setFinalTreeData, setAutocomplete,
  setBottlerData, setFilterApplied, setManageForecastTreeData, setManageForecastBottlerData, setManageForecastFinalTreeData,
  setStPeriodList, setLtPeriodList,setAllBottlerList,setAllCustomerList } = entitySlice.actions;
export default entitySlice.reducer;
